import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export const FEED_FILTERS_SOURCE_HASHTAG = "hashtag";

// What the chips filter on. Only hashtags today; the option exists so adding a
// second source later does not change the shape of every saved feed.
export default class FeedFiltersSource extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter by",
    component: inspectorTools.SIMPLE_PICKER,
    descriptionMessage: "What the chips above this feed filter on.",
    props: {
      options: [
        { name: "Hashtag", id: FEED_FILTERS_SOURCE_HASHTAG },
      ],
    },
  };

  static defaultValue = FEED_FILTERS_SOURCE_HASHTAG;
}
